import theme from "@styles/theme";
import EditSubmitButtonGroup from "@components_v2/edit-submit-button-group/edit-submit-button-group";
import { Grid, Box } from "@mzc-pdc/ui";

const FieldEditBox = ({ id, submitDisabled, submitPending, onClickSubmit, onClickClose, children, helperText }) => {
    return (
        <>
            <Grid item mt={theme.spacing(1)}>
                {children}
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item>{helperText && <Box>{helperText}</Box>}</Grid>
                <Grid item>
                    <EditSubmitButtonGroup
                        submitDisabled={submitDisabled}
                        submitPending={submitPending}
                        onClickSubmit={onClickSubmit}
                        onClickClose={() => onClickClose(id)}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default FieldEditBox;
